import React from 'react';
import { useTranslation } from 'react-i18next';
import DiagnosticCriteriaTable from '../../components/DiagnosticCriteriaTable';
import PvRiskCalculator from './PvRiskCalculator';
import { pvDiagnosticCriteria } from '../../data/diseasesData';

interface PvViewProps {
  activeTab: string;
}

const PvView: React.FC<PvViewProps> = ({ activeTab }) => {
  const { t } = useTranslation('hematology');

  // PV diagnosis rule: 3 major, OR first 2 major + minor
  const evaluatePvDiagnosis = (majorMet: number[], minorMet: number[]) => {
    const allThreeMajor = [1, 2, 3].every((n) => majorMet.includes(n));
    const firstTwoMajorPlusMinor =
      [1, 2].every((n) => majorMet.includes(n)) && minorMet.includes(1);

    if (allThreeMajor) {
      return { met: true, label: t('pv.diagnosisMet3Major') };
    }
    if (firstTwoMajorPlusMinor) {
      return { met: true, label: t('pv.diagnosisMetMajorMinor') };
    }
    return { met: false, label: t('pv.diagnosisNotMet') };
  };

  switch (activeTab) {
    case 'diagnosis':
      return (
        <DiagnosticCriteriaTable
          criteria={pvDiagnosticCriteria}
          title={t('pv.diagnosisTitle')}
          subtitle={t('pv.diagnosisSubtitle')}
          stateKey="pvDiagnosisCriteria"
          evaluateDiagnosis={evaluatePvDiagnosis}
        />
      );
    case 'risk':
      return <PvRiskCalculator />;
    default:
      return null;
  }
};

export default PvView;
